import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Carousel from "react-bootstrap/Carousel";
//부트 스트랩

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
//리엑트 슬릭

import "./App.css";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { Routes, Route, Link, useNavigate, Outlet } from "react-router-dom";
import axios from 'axios'
//기능

import newin from "./Data/new_in";
import top_seller from "./Data/top_seller";
import best_items from "./Data/best_item";
// 데이터들


// 서브페이지
import Product from './Product'; 
import Login from "./Login"
import About from "./About"

// 장바구니 카트 페이지
import Cart from './Cart'




function App() {
  let navigater = useNavigate();

  let [seller, setSeller] = useState(top_seller); //메인 옷 12개 데이터 js

  // let [res1, setRes1] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]); //사이트 주소 입력할 파라미터값(id)&


  return (
    <div className="App">
      {/* 헤더 네비바 */}
      <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary" style={{borderBottom:"1px solid #e5e5e5"}}>
        <Container>
          <Navbar.Brand
            onClick={() => {
              navigater("/");
            }}
            style={{ cursor: "pointer" }}
          >
            <img src="/img/top_logo.png" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <NavDropdown title="ALL CATEGORY" id="collasible-nav-dropdown">
                <NavDropdown.Item
                  onClick={() => {
                    navigater("/Product/3");
                  }}
                  style={{ fontSize: "13px" }}
                >
                  WOMAN
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => {
                    navigater("/Product/7");
                  }}
                  style={{ fontSize: "13px" }}
                >
                  MAN
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => {
                    navigater("/Product/11");
                  }}
                  style={{ fontSize: "13px" }}
                >
                  CAP
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link
                onClick={() => {
                  navigater("/Product/0");
                }}
                style={{ fontWeight: "bold" }}
              >
                PRODUCT
              </Nav.Link>

              <Nav.Link
                onClick={() => {
                  navigater("/Cart");
                }}
                style={{ fontWeight: "bold" }}
              >
                CART
              </Nav.Link>
            </Nav>
            <Nav>
              <Nav.Link
                onClick={() => {
                  navigater("/Login");
                }}
                style={{ fontWeight: "bold" }}
              >
                LOGIN
              </Nav.Link>
              <Nav.Link
                
                onClick={() => {
                  navigater("/About");
                }}
                style={{ fontWeight: "bold", }}
              >
                ABOUT
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* 헤더 네비 --------------------------------------------------*/}

      {/* 연결할 주소, 요소 */}
      <Routes>
        <Route
          path="/"
          element={
            <div>
              {/* 슬라이더1 ----------------------------------------------------------------------- */}

              <Carousel>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="/img/Gift_pc_banner_230419.jpg"
                    alt="First slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="/img/230523_porter_main-2_pc.jpg"
                    alt="Second slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="/img/Girl_pc_banner_230403_01.jpg"
                    alt="Third slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="/img/TVC_pc3.jpg"
                    alt="Third slide"
                  />
                </Carousel.Item>
              </Carousel>

              {/* TOP SELLER ---------------------------------------*/}
              <div
                className="container"
                style={{ marginTop: "60px" }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <h1 className="title">TOP SELLER</h1>
                  <span className="small_t">지금 가장 인기있는</span>
                </div>
              </div>

              {/* 버튼 */}
              <div
                className="container"
                style={{ textAlign: "center", marginTop: "20px" }}
              >
                <button type="button" class="btn btn-light btn-rounded" 
                onClick={()=>{
                  let copyName = [...seller].sort((a,b)=>
                    a.title > b.title ?1:-1
                  );
                  setSeller(copyName);
                  
                  
                }}>
                  이름 순
                </button>

                <button type="button" class="btn btn-light btn-rounded"
                onClick={()=>{
                  let copyDownprice = [...seller].sort((a,b)=>
                  parseInt(a.price) > parseInt(b.price) ?1:-1
                  ); 
                  setSeller(copyDownprice);
                  

                }}  
                >
                  가격 낮은 순
                </button>

                <button type="button" class="btn btn-light btn-rounded"
                onClick={()=>{
                  let copyUpPrice = [...seller].sort((a,b)=>
                  parseInt(b.price) > parseInt(a.price) ?1 :-1
                  );
                  setSeller(copyUpPrice);
                }}>
                  가격 높은 순
                </button>
              </div>

              {/* 서브로 이동할 옷들 */}
              <div className="container">
                <div className="row">
                  {seller.map((ele, i) => {
                    return <TopSeller seller={seller[i]} /*res1={res1}*/></TopSeller>;
                  })}
                </div>
              </div>


              {/* Brand Promotion */}
              <BrandPromotion></BrandPromotion>

              {/* NEW IN ----------------------------------------------------------------------- */}
              <NewIn></NewIn>

              

              {/* 슬라이드2*/}
              <Slide2></Slide2>

              {/* SPOTLIGHT CODI */}
              <Spotligt></Spotligt>

              {/* BEST ITEM */}
              <Best></Best>

              {/*끝 ---------------- */}
            </div>
          }
        />

          {/* 서브 PRODUCT 페이지 */}
        <Route path="Product/:id" element={<Product seller={seller}/>} /> {/*파라미터로 입력한 값의 사이트로 이동*/}

        {/* 장바구니 카트 페이지 */}
        <Route path="/cart" element={<Cart/>}/>  

        {/* 로그인 */}
        <Route path="/Login" element={<Login/>}/>  

        {/* 회사 */}
        <Route path="/About" element={<About/>}/>  

      </Routes>

      
      <Footer></Footer>
      





      
      {/* app div */}
    </div>
  );
}

//================================================================================


//slick 버튼 스타일 컴포넌트 
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "#ddd", borderRadius:"50px",  }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "#ddd", borderRadius:"50px" }}
      onClick={onClick}
    />
  );
}




//TOP SELLER 인기 상품 컴포넌트 -----------------------------------------------------------
function TopSeller(props) {

  // 사진 호버 펄스
  const [isListHover, setIsListHover] = useState(false);


  let navigate = useNavigate();

  const handleProductClick = () => {
    navigate("/Product/" + props.seller.id);
  };


  return (
    <>
      <div className="col-md-3" style={{ marginTop: "40px" }}>
        <Nav.Link
          onClick={handleProductClick}
        >
          <div className="imgBox" style={{ width: "100%" }} 
          onMouseOver={() => setIsListHover(true)}
          onMouseOut={() => setIsListHover(false)}>
            <img
              src={isListHover ? "/img/top_seller/" + props.seller.imgUrl2  :"/img/top_seller/" + props.seller.imgUrl}
              style={{ width: "100%" }}
            />
          </div>

          <div className="textBox" style={{ width: "100%", marginTop: "15px" }}>
            <h3 className="h3Style">{props.seller.title}</h3>
            <h4 className="h4Style"> {props.seller.code}</h4>
            <p className="Pstyle">{props.seller.price}원</p>
          </div>
        </Nav.Link>
      </div>
    </>
  );
}



//BRAND PROMOTION 컴포넌트 ------------------------------------------------------------
function BrandPromotion() {
  return (
    <>
      <div className="container" style={{  marginTop:"100px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h1 className="title">BRAND PROMOTION</h1>
          <span
            style={{
              marginTop: "10px",
              fontWeight: "bold",
              letterSpacing: "-1px",
              cursor: "pointer",
            }}
          >
            더 보러가기 &gt;
          </span>
        </div>
      </div>

      <div className="container" style={{ marginTop: "40px" }}>
        <div className="row">
          <div className="col-md-6" style={{ padding: "0", cursor: "pointer" }}>
            <img
              src="/img/event_outlet.jpg"
              alt="아울렛"
              style={{ width: "100%", height: "300px" }}
            />
          </div>
          <div className="col-md-6" style={{ padding: "0", cursor: "pointer" }}>
            <img
              src="/img/event_kakao.jpg"
              alt="카카오 채널 추가 이벤트"
              style={{ width: "100%", height: "300px" }}
            />
          </div>
        </div>
      </div>
    </>
  );
}



//NEW IN  컴포넌트 -----------------------------------------------------------
function NewIn() {
  let newinData = newin;

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    autoplay: true,
    autoplaySpeed:4000
  };
  return (
    <>
      <div
        className="container"
        style={{  marginTop: "60px" }}
      >
        <h1 className="title">NEW IN</h1>
        <p
          style={{ fontSize: "16px", color: "#1A1A1A", letterSpacing: "-1px" }}
        >
          이번주, 새롭게 공개된 말본골프의 컬렉션을 지금 바로 확인하세요.
        </p>
      </div>

      <div className="container">
        <Slider {...settings}>
          {newinData.map((ele, i) => (
            <div key={i} className="col-md-3">
              <div className="imgBox" style={{ width: "95%" }}>
                <img
                  src={"/img/new_in/" + newinData[i].imgUrl}
                  style={{ width: "100%", height: "100%", cursor: "pointer" }}
                />
              </div>
              <div className="textBox" style={{ marginTop: "15px" }}>
                <h3 className="h3Style">{newinData[i].title}</h3>

                <h4 className="h4Style">{newinData[i].code}</h4>
                <p className="Pstyle">{newinData[i].price}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
}




// 슬라이드2 --------------------------------------------------------------------
function Slide2(){
  const settings = {
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    autoplay: true,
    autoplaySpeed:3000
  };
return (

    <>
    
      {/* 슬라이더2 */}
      <div className="container" style={{ marginTop: "100px" }}>
                <Slider {...settings}>
                  <div>
                    <img src="/img/event02_banner1.jpg" alt="" />
                  </div>

                  <div>
                    <img src="/img/event02_banner2.jpg" alt="" />
                  </div>

                  <div>
                    <img src="/img/event02_banner3.jpg" alt="" />
                  </div>
                </Slider>
              </div>
    
    </>
)
}



//---------------------------------------------------------------------------

//SPOTLIGHT CODI 컴포넌트
function Spotligt() {

  const [isListHover1, setIsListHover1] = useState(false);
  const [isListHover2, setIsListHover2] = useState(false);
  const [isListHover3, setIsListHover3] = useState(false);

  const [isListHover4, setIsListHover4] = useState(false);
  const [isListHover5, setIsListHover5] = useState(false);
  const [isListHover6, setIsListHover6] = useState(false);

  const [isListHover7, setIsListHover7] = useState(false);
  const [isListHover8, setIsListHover8] = useState(false);
  const [isListHover9, setIsListHover9] = useState(false);

  return (
    <>
      <div
        className="container"
        style={{ marginTop: "90px" }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <h1 className="title">SPOTLIGHT CODI</h1>
          <span className="small_t">셋업으로 입어야 멋이나요!</span>
        </div>
      </div>

      <div className="container" style={{ marginTop: "40px" }}>
        <div className="row">
          <div className="col-md-4">
            <div className="bigBox">
              <div className="spImgBox">
                <img src="/img/codi1.jpg" alt="" />
              </div>

              <div className="txtBox">
                <span className="name">NEW SEASON WANTED</span>
                <span className="desc">
                  필드 위에서의 SPOTLIGHT. 스트릿한 감성의 새로운 컬렉션을 지금
                  확인하세요.
                </span>
                <span className="bg"></span>
              </div>

              <div className="clothesBox">
                <ul>
                  <li>
                    <div className="thumbnail" 
                    onMouseOver={() => setIsListHover1(true)}
                    onMouseOut={() => setIsListHover1(false)}>
                      <img src={isListHover1 ?"/img/spotlight_codi/Scodi1_1.jpg" :"/img/spotlight_codi/Scodi1.jpg"} alt="" />
                    </div>

                    <div className="description">
                      <h5>컬러 블록 아노락 WHITE (UNISEX)</h5>
                      <p>M3223PJK02WHT</p>
                      <span>359,000원</span>
                    </div>
                  </li>

                  <li>
                    <div className="thumbnail" 
                    onMouseOver={() => setIsListHover2(true)}
                    onMouseOut={() => setIsListHover2(false)}>
                      <img src={isListHover2 ?"/img/spotlight_codi/Scodi2_2.jpg" :"/img/spotlight_codi/Scodi2.jpg"} alt="" />
                    </div>

                    <div className="description">
                      <h5>테리 숏 팬츠 GREEN (MAN)</h5>
                      <p>M3221PHP02GRN</p>
                      <span>219,000원</span>
                    </div>
                  </li>

                  <li>
                    <div className="thumbnail"
                     onMouseOver={() => setIsListHover3(true)}
                     onMouseOut={() => setIsListHover3(false)}>
                      <img src={isListHover3 ?"/img/spotlight_codi/Scodi3_3.jpg" :"/img/spotlight_codi/Scodi3.jpg"} alt="" />
                    </div>

                    <div className="description">
                      <h5>스트라이프 로고 크루 삭스 IVORY</h5>
                      <p>M3143PSC03IVY</p>
                      <span>35,000원</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="bigBox">
              <div className="spImgBox">
                <img src="/img/codi2.jpg" alt="" />
              </div>

              <div className="txtBox">
                <span className="name">MALBON I SIGNATURE GRAPHIC</span>
                <span className="desc">
                  말본의 시그니처 그래픽으로 유니크하게
                </span>
                <span className="bg"></span>
              </div>

              <div className="clothesBox">
                <ul>
                  <li>
                    <div className="thumbnail"
                    onMouseOver={() => setIsListHover4(true)}
                    onMouseOut={() => setIsListHover4(false)}>
                      <img src={isListHover4 ?"/img/spotlight_codi/Scodi4_4.jpg" :"/img/spotlight_codi/Scodi4.jpg"} alt="" />
                    </div>

                    <div className="description">
                      <h5>말본 스크립트 메쉬 믹스 티셔츠 ORANGE (MAN)</h5>
                      <p>M3221PTS03ORG</p>
                      <span>259,000원</span>
                    </div>
                  </li>

                  <li>
                    <div className="thumbnail"
                    onMouseOver={() => setIsListHover5(true)}
                    onMouseOut={() => setIsListHover5(false)}>
                      <img src={isListHover5 ? "/img/spotlight_codi/Scodi5_5.jpg"  : "/img/spotlight_codi/Scodi5.jpg"} alt="" />
                    </div>

                    <div className="description">
                      <h5>말본 여름 와이드 팬츠 WHITE (MAN)</h5>
                      <p>M3221PPT04WHT</p>
                      <span>359,000원</span>
                    </div>
                  </li>

                  <li>
                    <div className="thumbnail" 
                    onMouseOver={() => setIsListHover6(true)}
                    onMouseOut={() => setIsListHover6(false)}>
                      <img src={isListHover6 ?"/img/spotlight_codi/Scodi6_6.jpg" : "/img/spotlight_codi/Scodi6.jpg"} alt="" />
                    </div>

                    <div className="description">
                      <h5>스트라이프 버킷 로고 크루 삭스 IVORY</h5>
                      <p>M3143PSC04IVY</p>
                      <span>39,000원</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="bigBox">
              <div className="spImgBox">
                <img src="/img/codi3.jpg" alt="" />
              </div>

              <div className="txtBox">
                <span className="name">SEASON COLOR</span>
                <span className="desc">
                  여름 시즌에 맞는 싱그러운 컬러의 룩으로 라운딩을 즐겨보세요!
                </span>
                <span className="bg"></span>
              </div>

              <div className="clothesBox">
                <ul>
                  <li>
                    <div className="thumbnail"
                     onMouseOver={() => setIsListHover7(true)}
                     onMouseOut={() => setIsListHover7(false)}>
                      <img src={isListHover7 ? "/img/spotlight_codi/Scodi7_7.jpg" :"/img/spotlight_codi/Scodi7.jpg"} alt="" />
                    </div>

                    <div className="description">
                      <h5>래빗 밴딩 바이저 WHITE (WOMAN)</h5>
                      <p>M3142PVS21WHT</p>
                      <span>109,000원</span>
                    </div>
                  </li>

                  <li>
                    <div className="thumbnail"
                    onMouseOver={() => setIsListHover8(true)}
                    onMouseOut={() => setIsListHover8(false)}>
                      <img src={isListHover8 ?"/img/spotlight_codi/Scodi8_8.jpg" :"/img/spotlight_codi/Scodi8.jpg"} alt="" />
                    </div>

                    <div className="description">
                      <h5>[Rabbit] 래빗 버킷 스웨터 SKY BLUE (WOMAN)</h5>
                      <p>M3122PKT14SBL</p>
                      <span>359,000원</span>
                    </div>
                  </li>

                  <li>
                    <div className="thumbnail"
                    onMouseOver={() => setIsListHover9(true)}
                    onMouseOut={() => setIsListHover9(false)}>
                      <img src={isListHover9 ? "/img/spotlight_codi/Scodi9_9.jpg" : "/img/spotlight_codi/Scodi9.jpg"} alt="" />
                    </div>

                    <div className="description">
                      <h5>[Rabbit] 미니 파우치 래빗 스커트 WHITE (WOMAN)</h5>
                      <p>M3122PSK13WHT</p>
                      <span>439,000원</span>
                    </div>
                  </li>

                </ul>
              </div>
            </div>
          </div>

          {/* row --- */}
        </div>
      </div>
    </>
  );
}



// BEST ITEM 컴포넌트-------------------------------------------------
function Best() {
  
  let [bestItem, setBestItem] = useState(best_items);

  let [count , setCount]= useState(1);

  

  return (
    <>
      <div
        className="container"
        style={{marginTop: "80px" }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <h1 className="title">BEST ITEM</h1>
          <span className="small_t">
            지금 말본골프의 인기있는 상품들을 만나보세요.{" "}
          </span>
        </div>
      </div>


      <div className="container" style={{textAlign:"center", marginTop:"30px"}}>
        <button type="button" class="btn btn-outline-primary" onClick={()=>{
          if(count==1){
            axios
              .get(
                "https://rlaquf1004.github.io/reacte_MB_data/bestData.json"
              )
              .then ((plus)=>{
                let copy = [...bestItem, ...plus.data];
                setBestItem(copy);
                setCount(2);
              })
          }else {
            alert("더 이상 상품이 없습니다")
          }
        }}>상품 더보기</button>
      </div>


      <div className="container" style={{marginTop:"30px"}}>
        
        <div className="row">
          {bestItem.map((ele, i) => {
            return (
              <>
                <div className="col-md-3">
                  <div className="Bst_imgBox">
                    <img src={bestItem[i].imgUrl} />
                  </div>
                  <div className="Bst_textBox">
                    <h3 className="h3Style">{bestItem[i].title}</h3>
                    <h4 className="h4Style">{bestItem[i].code}</h4>
                    <p className="Pstyle">{bestItem[i].price}</p>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
    </>
  );
}



// 푸터 컴포넌트
function Footer(){

  return (
    <>
    
      <div className="footer" >

        <div className="container" style={{ borderTop:"1px solid #e5e5e5" , paddingTop:"70px"}}>
          <div className="row footerWrapBox">
            <div className="col-md-4 left_fot_box">
              <img src="/img/bt_logo.png"/>

              <ul class="malbon_ul_left">
                <li><a href="#">회사소개</a></li>
                <li>|</li>
                <li><a href="#">이용안내</a></li>
                <li>|</li>
                <li><a href="#" className="privacy">개인정보방침</a></li>
                <li>|</li>
                <li><a href="#">이용약관</a></li>
                <li>|</li>
                <li><a href="#">구매안전(에스크로)서비스</a></li>
              </ul>

              <div className="footer_info">
					      계좌번호 : 신한은행 140-013-349110 &nbsp;&nbsp;|&nbsp;&nbsp; 상호명 : 주식회사 하이라이트브랜즈<br/>
                말본골프 | malbon golf &nbsp;&nbsp;| &nbsp;&nbsp;대표이사 : Jun Kwon Lee &nbsp;&nbsp;| &nbsp;&nbsp;주소 : 13487 경기도 성남시 분당구 판교로 242 (삼평동) PDC 빌딩 A동 8F<br/>
                통신판매업신고 : 2019-성남분당B-0523 &nbsp;&nbsp;|&nbsp;&nbsp; 사업자등록번호 : 788-81-01239 <br/>
                개인정보취급관리자 : 하이라이트브랜즈<br/>
                이메일 : support@hibs.co.kr&nbsp;&nbsp; |&nbsp;&nbsp; 고객센터 : 031-8060-0290<br/>
                대리점 입점 문의 : jisoo.son@hibs.co.kr &nbsp;&nbsp;| &nbsp;&nbsp;마케팅제휴 : marketing@hibs.co.kr  
              </div>

              <div className="copyright">
                Copyright by 말본골프 | malbon golf. all rights reserved.
              </div>
            </div>

          
            <div className="col-md-4 right_fot_box">
              <ul className="malbon_ul_right">
                <li>NOTICE</li>
                <li>REVIEW</li>
                <li>매장안내</li>
              </ul>
              <ul className="malbon_ul_right">
                <li>마이페이지</li>
                <li>주문배송조회</li>
                <li>위시리스트</li>
                <li>1:1 문의</li>
              </ul>
              <ul className="malbon_ul_right">
                <li>Facebook</li>
                <li>Instagram</li>
              </ul>
            </div>

          </div>
        </div>

      </div>

    </>
  )


}













export default App;
